import { useQuery } from '@tanstack/react-query';
import { userManagementAPI } from '../api/users.api';
import type { UserFilters, User } from '../types';

export const useUsers = (filters?: UserFilters) => {
  return useQuery({
    queryKey: ['users', filters],
    queryFn: async () => {
      const response = await userManagementAPI.getUsers(filters);
      if (response.success) {
        // Response is { success, data: { users: User[], count: number } }
        const data = response.data as { users: User[]; count: number } | User[];
        // Handle both formats: { users: [...] } or direct array
        if (Array.isArray(data)) {
          return data;
        }
        return data?.users ?? [];
      }
      throw new Error(response.message || 'Failed to fetch users');
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
    refetchOnWindowFocus: false
  });
};